import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getDealerDetailsSearchResultsUrl } from 'site-modules/shared/utils/dealerships/dealer-inventory';
import { Link } from 'site-modules/shared/components/link/link';

export function DealerDetailsSearchResultsElement({
  children,
  locationId,
  inventoryType = '',
  makeModel = {
    make: '',
    model: '',
  },
  dataTrackingValue = '',
  isLink = true,
  className = '',
  isHidden = false,
}) {
  return isLink ? (
    <Link
      to={getDealerDetailsSearchResultsUrl(locationId, inventoryType, makeModel)}
      className={classnames(className)}
      data-tracking-id="ddp_view_search_result"
      data-tracking-value={dataTrackingValue}
      tabIndex={isHidden ? -1 : 0} // when this element is hidden via aria-hidden on a parent, then we need to remove tabindex so you can't tab to it.
    >
      {children}
    </Link>
  ) : (
    <span>{children}</span>
  );
}

DealerDetailsSearchResultsElement.propTypes = {
  locationId: PropTypes.number.isRequired,
  inventoryType: PropTypes.string,
  makeModel: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
  }),
  dataTrackingValue: PropTypes.string,
  children: PropTypes.node.isRequired,
  isLink: PropTypes.bool,
  isHidden: PropTypes.bool,
  className: PropTypes.string,
};
